import axios from "axios";
import { useQuery} from 'react-query'
import { getAllItems} from "../../auxiliary/AxiosAPI/AxiosAPI";

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";

const DataContext = createContext({});
const useGetAll = ()=>{
  return useQuery('getAllItems', getAllItems,
  {
    onSuccess:(data)=>{
      return data
    }
  })
}

export const DentistConferenceContextProvider = ({ children }) => {


  const {data, status} = useGetAll()
  const [filteredData, setFilteredData]= useState([])
  const [state, setState] = useState({
    data: data?.data,
    message: data?.message,
    dataItem: data?.element,
    isLoading:status,
    isError:status,
    error:status 
});
const [activeElement, setActiveElement] = useState(null);

  useEffect(() => {
    if (status === "success") {
      setState(() => {
        return {
          data: data?.data,
          message: data?.message,
          dataItem: data?.element,
          isLoading: false,
          isError: false,
          error: status,
        };
      });
      setFilteredData(state.data);
    } else {
      setState(() => {
        return {
          data: [],
          message: "Loading...",
          dataItem: {},
          isLoading: true,
          isError: (status==='error') ? true:false,
          error: (status==='error') ? "المخدم متوقف" : "جاري ارسال المعلومات",
        };
      });
    }
  }, [data]);

  return (
    <DataContext.Provider
      value={{
        state,
        filteredData,
        activeElement,
        setState,
        setActiveElement,
        setFilteredData,
     }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
